import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AppState } from '../../../../../app.service';
import { Service } from './restore-points.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { constructInnerTableRestorePoints } from '../../../dataprotection-common/common-renderers';
import { DataProtectionVariables } from '../../../dataprotection-common/dataprotection-variables';
import { Modal } from '@clr/angular';
import { StorageComparator } from './restore-point-storage-comparator';
var $ = require('jquery');

@Component({
  selector: 'restore-points',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./restore-points.scss')],
  template: require('./restore-points.html')
})

export class RestorePoints {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedEntity') selectedEntity;
  @Output('onRequestStatusChange') emitter = new EventEmitter();

  private tableData:any = [];
  private subscribeHandler;
  private selected:any = [];
  private currentSelection;
  private restorePointForUpdation;
  private isRowSelected: boolean = false;
  private isTranslationready:boolean = true;
  private isExpiryDateListeningEnabled: boolean = true;
  private isDeleteRestoreModalVisible: boolean = false;
  private isRefreshRestoreModalVisible: boolean = false;
  private isInPlaceRestoreModalVisible: boolean = false;
  private isOutOfPlaceRestoreModalVisible: boolean = false;
  private isDeletedVmMode:boolean = false;
  private isModalClosable: boolean = true;
  private storageComparator = new StorageComparator('storageConsumed');
  private sizeComparator = new StorageComparator('size');
  private creationDateComparator = new StorageComparator('creationDate', 'date');
  private expiryDateComparator = new StorageComparator('expiryDate', 'date');

  constructor(public appState: AppState, public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    /** Defer the REST call to fetch data, until the component is visible (else too many REST calls while loading).
     * This also helps in fixing the bug 'column headers are misaligned'
     * */
    if ( !this.isVisible ) { this.reset(); }
    if(changes && changes.hasOwnProperty('isVisible') && changes.isVisible && changes.isVisible.hasOwnProperty('currentValue') && changes.isVisible.currentValue
        && this.selectedEntity && this.selectedEntity.entity_id && this.selectedEntity.vcenter_instanceId) {
        this.getRestorePoints();
    }
  }

  reset() {
    this.tableData = [];
    this.isRowSelected = false;
    this.selected = [];
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) {
      this.subscribeHandler.unsubscribe();
    }
  }

  onGridSelectionChange(selection) {
    if (selection && selection.entityId) {
      this.currentSelection = selection;
      this.isRowSelected = true;
    } else {
      this.isRowSelected = false;
    }
  }

  onInPlaceRestore(event) {
    this.isInPlaceRestoreModalVisible = true;
  }

  onDeleteRestore(event) {
    this.isDeleteRestoreModalVisible = true;
  }

  onRefreshRestore(event) {
    this.isRefreshRestoreModalVisible = true;
  }

  onOutOfPlaceRestore(event) {
    this.isOutOfPlaceRestoreModalVisible = true;
  }

  onDeleteRestoreClose(emittedData) {
    if (!emittedData) {
        this.isDeleteRestoreModalVisible = false;
        this.isModalClosable = true;
    } else if (emittedData.status === 'pending') {
        this.isModalClosable = false;
    } else if (emittedData.status === 'success') {
        this.isDeleteRestoreModalVisible = false;
        this.isModalClosable = true;
        this.emitter.emit();
    } else {
        this.isModalClosable = true;
    }
  }

  onRefreshRestoreClose(emittedData) {
    if (!emittedData) {
        this.isRefreshRestoreModalVisible = false;
        this.isModalClosable = true;
    } else if (emittedData.status === 'pending') {
        this.isModalClosable = false;
    } else if (emittedData.status === 'success') {
        this.isRefreshRestoreModalVisible = false;
        this.isModalClosable = true;
        this.emitter.emit();
    } else {
        this.isModalClosable = true;
    }
  }

  onInPlaceRestoreClose(emittedData) {
    if (!emittedData) {
        this.isInPlaceRestoreModalVisible = false;
        this.isModalClosable = true;
    } else if (emittedData.status === 'pending') {
        this.isModalClosable = false;
    } else if (emittedData.status === 'success') {
        this.isInPlaceRestoreModalVisible = false;
        this.isModalClosable = true;
        this.emitter.emit();
    } else {
        this.isModalClosable = true;
    }
  }

  onOutPlaceRestoreClose(event) {
    if (event && event.value) {
      this.isOutOfPlaceRestoreModalVisible = false;
      this.emitter.emit();
    }
  }

  getRestorePoints() {
    if (this.mode && this.selectedEntity && this.selectedEntity.entity_id && this.selectedEntity.vcenter_instanceId) {
      switch(this.mode) {
        case DataProtectionVariables.RESTORE_MODES['VM']:
          this.isDeletedVmMode = false;
          this.getRestorePointsForVm(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId);
          break;
        case DataProtectionVariables.RESTORE_MODES['DELETED_VM']:
          this.isDeletedVmMode = true;
          this.getRestorePointsForDeletedVm(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId);
          break;
        default :
          this.getRestorePointsForVm(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId);
      }
    }
    else {}
  }

  getRestorePointsForVm(vmId, vcId) {
    this.subscribeHandler = this.service.getRestorePointsForVm(vmId, vcId)
      .subscribe(
        tableData => {
          this.tableData = tableData;
        },
        error => this.logError(error, 'get restore points for vm'),
        () => {}
      );

  }

  getRestorePointsForDeletedVm(vmId, vcId) {
    this.subscribeHandler = this.service.getRestorePointsForDeletedVm(vmId, vcId)
      .subscribe(
        tableData => {
          this.tableData = tableData;
          for (let i = 0; i < this.tableData.length; i += 1) {
            let rp = this.tableData[i];
            let d = new Date(rp.creationDate);
          }
        },
        error => this.logError(error, 'get restore points for deleted vm'),
        () => {}
      );
  }

  logError(error, origin:String = '') {
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
  }

  logOperationCompleted(msg: string) {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/restore-points/restore-points.component.ts